import React, { useRef } from 'react'
import { Services } from '@/services/services';
import { CurrentSession, SessionService } from '@/services/repository/session';
import { PageQuery, PageResponse, SearchTable, SearchTableParams, SearchTableRef } from '@/components/search/SearchTable';
import { formatDate } from '@/common/time';

export interface CardEvent {
  cardId: string
  dtTracker: string
}

// export interface CardResponse {
//   cards: CardEvent[] | null
// }

// export const  = ({ services, session, machineId }: { services: Services, session: CurrentSession, machineId: string }) => {
//   const [cardResponse, setCardResponse] = useState<CardResponse | undefined>()
//   const [machine, setMachine] = useState<MachineFormData>()

//   useEffect(() => {
//     if (machineId === undefined) {
//       return
//     }
//     setCardResponse(undefined)
//     services.session.fetchWithToken(`/api/serviceman/machines/byid/${machineId}/cards`).then((r) => {
//       if (r.status === 200) {
//         return r.json()
//       }
//       return Promise.reject()
//     }).then((data) => {
//       setCardResponse(data)
//     })
//   }, [machineId])

//   useEffect(() => {
//     if (machineId === undefined) {
//       return
//     }
//     setMachine(undefined)
//     services.session.fetchWithToken(`/api/serviceman/machines/byid/${machineId}`).then((r) => {
//       if (r.status === 200) {
//         return r.json()
//       }
//       return Promise.reject()
//     }).then((data) => {
//       setMachine(data)
//     })
//   }, [machineId])

//   if(machine===undefined || cardResponse===undefined) {
//     return <div className='spinner'></div>
//   }

//   return <div>
//     <table>
//     {cardResponse?.cards?.map((row) => <tr><td>{formatDate(new Date(row.date))}</td><td>{row.id}</td></tr>)}
//     </table>
//   </div>
// }

export const CardHistoryBody = ({ services, session, machineId, onClose }: { services: Services, session: CurrentSession, machineId: string | undefined, onClose: () => void }) => {
  const searchTableRef = useRef<SearchTableRef>(null)

  const tableParams: SearchTableParams<CardEvent> = {
    fetch: (q: PageQuery): Promise<PageResponse<CardEvent>> => {
      return services.session.fetchWithToken(`/api/serviceman/machines/byid/${machineId}/cards/search?pageNumber=${q.pageNumber || ''}&pageSize=${q.pageSize || ''}&search=${q.search || ''}`).then((r) => {
        if (r.status === 200) {
          return r.json()
        }
        return Promise.reject(session.translates.for('errors.no_tracking_device'))
      })
    },
    pageQuery: {
      pageNumber: 1,
      pageSize: 6,
      search: ""
    },
    toolbox: () => <></>,
    header: () => <>
      <div className='hcol'>{session.translates.for('elements.table.cards.dt_server')}</div>
      <div className='hcol'>{session.translates.for('elements.table.cards.card_id')}</div>
    </>,
    row: (row, state, setState) => <>
      <div className='col'>{formatDate(new Date(row.dtTracker))}</div>
      <div className='col'>{row.cardId}</div>
    </>,
    translates: session.translates
  }

  return <SearchTable ref={searchTableRef} {...tableParams} />
}
